// hooks/usePreviewPane.js
// Hook état du panneau preview — Session 20

import { useState, useCallback } from 'react';

/**
 * @returns {{ previewContent, isPreviewOpen, showPreview, closePreview }}
 * previewContent: { type: 'docx'|'html'|'markdown', filename, url, size, content? }
 */
export default function usePreviewPane() {
  const [previewContent, setPreviewContent] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const showPreview = useCallback((content) => {
    setPreviewContent(content);
    setIsPreviewOpen(true);
  }, []);

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
  }, []);

  return { previewContent, isPreviewOpen, showPreview, closePreview };
}
